<template>
  <BusinessHeader />
  <main class="bg-grey-light-950 text-foreground min-h-screen">
    <router-view />
  </main>
  <FooterComponent :showSocials="showSocials" />
</template>

<script setup lang="ts">
import BusinessHeader from '@/components/business/BusinessHeader.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import { useThemeStore } from '@/stores/theme';
import { computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const themeStore = useThemeStore();
const showSocials = computed(() => (route.meta.showSocials as boolean) ?? false);

// Set mode to business when this layout is mounted
onMounted(() => {
  themeStore.setMode('business');
});

// Reset to shopper mode when leaving business section
onUnmounted(() => {
  themeStore.setMode('shopper');
});
</script>
